/* eslint-disable import/prefer-default-export */

import { USERS_EDIT } from 'src/store/ActionTypes';

export const fetchUser = (query) => ({
  type: USERS_EDIT.FETCH_USER,
  payload: query,
});

export const resendInvitation = (username) => ({
  type: USERS_EDIT.RESEND_INVITATION,
  payload: username,
});

export const resetPassword = (username) => ({
  type: USERS_EDIT.RESET_PASSWORD,
  payload: username,
});

export const editUser = (userId, user) => ({
  type: USERS_EDIT.EDIT_USER,
  payload: {
    userId,
    user,
  },
});
